import { t } from 'i18next';
import { Sparkle } from 'lucide-react';

import { platformHooks } from '@/hooks/platform-hooks';
import { AskAiButtonOperations } from '@/features/pieces/lib/types';
import { Button, ButtonProps } from './ui/button';
import { useBuilderStateContext } from '@/app/builder/builder-hooks';


const AskAiBuilderButton = ({
  variant,
}: {
  variant: ButtonProps['variant'];
}) => {

  const setAskAiBuilderButtonProps = useBuilderStateContext(
    (state) => state.setAskAiBuilderButtonProps,
  );

  return (
    <Button
      variant={variant}
      size="sm"
      onClick={setAskAiBuilderButtonProps}
    >
      <div className="flex gap-2 items-center ">
        <Sparkle className="w-4 h-4 "></Sparkle> {t('AI Builder')}
      </div>
    </Button>
  );
};

AskAiBuilderButton.displayName = 'AskAiBuilderButton';
export { AskAiBuilderButton };
